module.exports = __webpack_public_path__ + "img/module2.png";